export default "__VITE_PUBLIC_ASSET__ace6a7ca__"